import { en_US, it_IT } from 'ng-zorro-antd/i18n';

export const LOCALE_CONFIG: any = {
  'en-us': en_US,
  'it-it': it_IT,
  it: it_IT,
};
